import { Component, ElementRef, Input, AfterViewInit, ViewChild, OnChanges, SimpleChanges } from "@angular/core";

@Component({
    selector: "cs-animated-digit",
    templateUrl: "./animated-digit.component.html"
})
export class AnimatedDigitComponent implements AfterViewInit, OnChanges {
    @Input() duration: number;
    @Input() digit: number = null;
    @Input() steps: number;
    @ViewChild("animatedDigit") animatedDigit: ElementRef;

    animateCount() {        
        if (!this.duration) {
            this.duration = 1000;
        }

        if (typeof this.digit === "number" && this.digit >= 0) {
            this.counterFunc(this.digit, this.duration, this.animatedDigit);
        }
        else {
            this.negetiveCounterFunc(this.digit, this.duration, this.animatedDigit);
        }
    }

    negetiveCounterFunc(endValue: number, durationMs: number, element: any) {
        if (!this.steps) {
            this.steps = 12; // Number of steps in the animation
        }

        const stepCount = Math.abs(durationMs / this.steps); // Total steps based on duration
        const valueIncrement = (0 - endValue) / stepCount; // Increment towards the negative endValue
        const sinValueIncrement = Math.PI / stepCount; // Sine increment for smooth animation

        let currentValue = 0; // Start value
        let currentSinValue = 0; // Sine progress tracker

        function step() {
            currentSinValue += sinValueIncrement;
            currentValue -= valueIncrement * Math.sin(currentSinValue) ** 2 * 2; // Decrement using sine easing

            if (element) {
                element.nativeElement.textContent = Math.floor(currentValue); // Update UI
            }

            if (currentSinValue < Math.PI) {
                window.requestAnimationFrame(step); // Continue animation
            } else {
                element.nativeElement.textContent = endValue; // Ensure it ends exactly at the endValue
            }
        }

        step(); // Start the animation
    }

    counterFunc(endValue, durationMs, element) {
        if (!this.steps) {
            this.steps = 12;
        }

        const stepCount = Math.abs(durationMs / this.steps);
        const valueIncrement = (endValue - 0) / stepCount;
        const sinValueIncrement = Math.PI / stepCount;

        let currentValue = 0;
        let currentSinValue = 0;

        function step() {
            currentSinValue += sinValueIncrement;
            currentValue += valueIncrement * Math.sin(currentSinValue) ** 2 * 2;

            if (element)
                element.nativeElement.textContent = Math.abs(Math.floor(currentValue));

          if (currentSinValue < Math.PI) {
            window.requestAnimationFrame(step);
          }
          else {
            element.nativeElement.textContent = endValue;
          }
        }

        step();
    }

    ngAfterViewInit() {
        if (this.digit) {
            this.animateCount();
        }
        else {            
            this.animatedDigit.nativeElement.textContent = 0;
        }
    }

    ngOnChanges(changes: SimpleChanges) {        
        if (changes["digit"] && changes.digit.previousValue != changes.digit.currentValue) {
            this.animateCount();
        }
    }
}
